export const LOCAL_STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER: 'user',
  SUPER_USER: 'superuser',
  JOINED_AT: 'joined_at',
  LANGUAGE: 'lang',
  MASKED_EMAIL: 'masked_email',
  MASKED_PHONE: 'masked_phone',
  ENC: 'enc',
  SHOULD_CREATE_LOGIN_TOKEN: 'shouldCreateEmailsToken',
  DOCTOR_ADDED: 'doctor_added',
  DOCTOR_SHARED: 'doctor_shared',
};
